// extracted by mini-css-extract-plugin
module.exports = {"list":"DropdownMenuMobile_list__NJ5Oo"};